import { createContext, useContext } from 'react';
import { UserMode } from './useApolloClient';

const context = createContext<UserMode>('water-supplier');
export const useMode = () => {
  return useContext(context);
};

const { Provider: ModeProvider } = context;

export { ModeProvider, useMode as default };
